module.exports = __webpack_public_path__ + "static/img/ysfx2.69ec268.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/ysfx2.png
// module id = XYBj
// module chunks = 0